<app-popup-layout #modal>
  <header class="modal-header">
    <app-close-button
      class="ms-auto"
      (onCloseEmitter)="modal.dismiss()"
    ></app-close-button>
  </header>
  <div class="modal-container p-5">
    <img
      src="assets/home/bell-notifier.png"
      class="bell-icon mb-3"
      alt="Bell"
    />

    <p class="p-0 title mt-3">We have notified your employer!</p>

    <button
      mat-flat-button
      color="primary"
      class="custom-button-submit mt-3"
      (click)="modal.dismiss()"
    >
      Okay
    </button>
  </div>
</app-popup-layout>
